import { render, staticRenderFns } from "./reports-activity-reporting-tab.vue?vue&type=template&id=b6058052&scoped=true"
import script from "./reports-activity-reporting-tab.vue?vue&type=script&lang=js"
export * from "./reports-activity-reporting-tab.vue?vue&type=script&lang=js"
import style0 from "./reports-activity-reporting-tab.vue?vue&type=style&index=0&id=b6058052&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6058052",
  null
  
)

export default component.exports